import { render, staticRenderFns } from "./UsuarioInativo.vue?vue&type=template&id=8b0d4ff2"
import script from "./UsuarioInativo.vue?vue&type=script&lang=js"
export * from "./UsuarioInativo.vue?vue&type=script&lang=js"
import style0 from "./UsuarioInativo.vue?vue&type=style&index=0&id=8b0d4ff2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports